/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorConversationsEditRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.conversations.edit',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorConversationsEditRoute);
